import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { GalleryPath, LeadsUpload, LeadsUpload1, MessageUpload1 } from '../../app-routing.module';
import { DidService } from '../../dids/did.service';
import { UploadviewComponent } from '../uploadview/uploadview.component';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'app-did-details',
  templateUrl: './did-details.component.html',
  styleUrls: ['./did-details.component.css']
})
export class DidDetailsComponent implements OnInit {
  @ViewChild(UploadviewComponent,{static:true}) childComponent: UploadviewComponent;
  didStateCount: any;
  newarr: any[];
  valuestate: string;
  TargetURL = LeadsUpload + '/uploadDID'
  result4DID: any;
  constructor(protected data: DidService,@Inject(MAT_DIALOG_DATA) public data1: any, private dialogRef: MatDialogRef<DidDetailsComponent>,private dialog:MatDialog, protected snackBar?: MatSnackBar) { }
  onUpload(event:any){
    console.log('event',event);
    this.openSnackBar(event.message,'clear')
    this.data.getService('file', JSON.stringify({ id_group: this.data1 })).subscribe(res => {
      this.didStateCount = res;
      this.dialogRef.close()
    })
  }
  ngOnInit() {
    console.log(this.data1)
    if(this.data1 instanceof Object){
      console.log(this.data1)
      this.data1=this.data1.id
      // this.get_header()
      // setTimeout(() => {
      //   this.childComponent.onClick()
      // }, 500);
      // this.childComponent.onClick()
      // this.dialogRef.close()
    }
    // this.data.CountStateDID(this.data1).subscribe(res => {
    //   this.didStateCount = res.records;
      
    //   console.log(this.didStateCount)
    //   if(this.didStateCount!=''){
       
    //     this.newarr = [];
    //     for (var key in this.didStateCount) {
    //       var value = this.didStateCount[key];
    //       this.valuestate = value.state + '-' + value.num;
    //       this.newarr.push(this.valuestate)
    //     }
        
    //   }
    // });
       this.data.getService('file', JSON.stringify({ id_group: this.data1 })).subscribe(res => {
      this.didStateCount = res;
      
      console.log('yyty',this.didStateCount)
      // if(this.didStateCount!=''){
       
      //   this.newarr = [];
      //   for (var key in this.didStateCount) {
      //     var value = this.didStateCount[key];
      //     this.valuestate = value.state + '-' + value.num;
      //     this.newarr.push(this.valuestate)
      //   }
        
      // }
    });
  }
  close(){
    this.dialogRef.close();
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000
      , verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['snackbarwarn']
    });
  }
}
